// Status chip used in nav, domain pages, product cards, and pricing tables.
// LIVE = orange; everything else (IN DEVELOPMENT / PLANNED / COMING) = slate.
export default function StatusChip({ status, className = "", testid }) {
  const live = status === "LIVE";
  const cls = live ? "bg-[#FF8A00] text-[#050A15]" : "bg-[#E2E8F0] text-[#475569]";
  return (
    <span
      data-testid={testid}
      className={`inline-block font-mono text-[10px] font-bold uppercase tracking-[0.1em] px-2 py-1 leading-none ${cls} ${className}`}
    >
      {status}
    </span>
  );
}
